import {debounce} from 'helpers';
import {store} from 'store';

export const linkGoalActivities = debounce(category => {
  store.dispatch({
    type: 'CLARITY_LINK_GOAL_ACTIVITIES',
    category,
  });
}, 500);
